import cloneDeep from 'lodash/cloneDeep';
import {
  PersonalizationSettings,
  PersonalizationCategoryChannelUpdateData,
  PersonalizationEventChannelUpdateData,
} from '@/api/apis/communication/personalization';

export const updatePersonalizationCategoryChannel =
  ({ categoryName, channelType, data }: PersonalizationCategoryChannelUpdateData) =>
  (prevSettings: PersonalizationSettings | undefined): PersonalizationSettings | undefined => {
    if (!prevSettings) return prevSettings;

    const nextSettings = cloneDeep(prevSettings);

    const category = nextSettings.categories.find((c) => c.name === categoryName);
    if (!category) return prevSettings;

    category.notifications.forEach((notification) => {
      const channel = notification.channels.find((ch) => ch.type === channelType);
      if (channel) {
        channel.enabled = data.enabled;
      }
    });

    return nextSettings;
  };

export const updatePersonalizationEventChannelMutation =
  ({ categoryName, eventName, channelType, data }: PersonalizationEventChannelUpdateData) =>
  (prevSettings: PersonalizationSettings | undefined): PersonalizationSettings | undefined => {
    if (!prevSettings) return prevSettings;

    const nextSettings = cloneDeep(prevSettings);

    const category = nextSettings.categories.find((c) => c.name === categoryName);
    if (!category) return prevSettings;

    const notification = category.notifications.find((n) => n.name === eventName);
    if (!notification) return prevSettings;

    const channel = notification.channels.find((ch) => ch.type === channelType);
    if (!channel) return prevSettings;

    channel.enabled = data.enabled;

    return nextSettings;
  };
